import React from 'react';
import {withTranslation} from 'react-i18next';
import i18next from 'i18next';

class MKboComp extends React.Component {
    componentDidMount() {
        const savedLang = window.localStorage.getItem("i18Lang");
        if (!savedLang) {
            const browserLang = (navigator.language || navigator.userLanguage).toLowerCase();
            if (!browserLang.startsWith('ko')) {
                this.changeLanguage('en');
            }
        }

        if (window.gtag) {
            window.gtag('event', 'page_view', {
                page_title: 'KBO Event',
                page_location: window.location.href,
            });
        }
    }

    changeLanguage = (lang) => {
        i18next.changeLanguage(lang);
    };

    render() {
        const {t} = this.props;

        let imagePostfix = '.png';
        if (i18next.language === 'en') {
            imagePostfix = '_en.png';
        }

        const images = [
            'img-kbo2',
            'img-kbo3',
            'img-kbo4',
            'img-kbo5',
            'img-kbo6',
            'img-kbo7',
            'img-kbo8',
            'img-kbo9',
            'img-kbo10',
        ];

        const headerHeight = '54px';

        const overlayBtnBase = {
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '78%',
            cursor: 'pointer',
            zIndex: 15,
            backgroundColor: 'transparent',
            border: 'none',
            outline: 'none',
        };
        const appBtnStyle = { ...overlayBtnBase, bottom: '14.5%', height: '58%' };
        const naverBtnStyle = { ...overlayBtnBase, bottom: '19%', height: '81%' };

        const isEn = i18next.language === 'en';

        return (
            <>
                <header style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    zIndex: 1000,
                    boxSizing: 'border-box',
                    height: headerHeight,
                    backgroundColor: '#000000',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingLeft: '24px',
                    paddingRight: '24px'
                }}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <img
                            src="https://asset.981park.com/www/common/web/img/common/logo/981-park.svg"
                            alt="981 PARK"
                            style={{width: '94.7px', height: '30px', cursor: 'pointer'}}
                            onClick={() => window.open('https://981park.com', '_blank', 'noopener,noreferrer')}
                        />
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '19px'}}>
                        <span className="typo1" style={{color: 'white', fontSize: '15px', cursor: 'pointer'}}
                              onClick={() => this.changeLanguage('ko')}>{t('Lang_ko')}</span>
                        <span className="typo1" style={{color: 'white', fontSize: '15px', cursor: 'pointer'}}
                              onClick={() => this.changeLanguage('en')}>{t('Lang_en')}</span>
                    </div>
                </header>

                <div className="park-wrap" style={{paddingTop: headerHeight}}>
                    <div className="info">
                        <div style={{
                            backgroundColor: '#ffffff',
                            padding: '18px 24px 0',
                            height: '179px',
                            boxSizing: 'border-box',
                        }}>
                            <div style={{
                                fontFamily: "'Spoqa Han Sans Neo', sans-serif",
                                fontWeight: 700,
                                fontSize: '24.5px',
                                lineHeight: '36px',
                                letterSpacing: '-0.98px',
                                color: '#000000',
                                whiteSpace: 'pre-line',
                            }}>
                                {isEn
                                    ? 'Join the\n<KBO 981League>\nright now!'
                                    : '9.81파크 제주,\n내 꿈은 <KBO 981리그 >\n응원단장 시즌 개막!'}
                            </div>
                            <p style={{
                                fontFamily: "'Spoqa Han Sans Neo', sans-serif",
                                fontWeight: 500,
                                fontSize: '13px',
                                lineHeight: '36px',
                                color: '#9e9e9e',
                                margin: 0,
                            }}>
                                2026.03.28 - 2026.11.12
                            </p>
                        </div>
                        <div className="img-wrap">
                            <div className="img">
                                {images.map((name) => (
                                    <div key={name} style={{position: 'relative'}}>
                                        <img
                                            src={`https://981park-jeju-asset.s3.ap-northeast-2.amazonaws.com/www/common/mweb/img/sub/event/${name}${imagePostfix}`}
                                            alt=""
                                            style={{width: '100%', height: 'auto', display: 'block', verticalAlign: 'top'}}
                                            loading="lazy"
                                        />
                                        {name === 'img-kbo4' && (
                                            <button
                                                style={appBtnStyle}
                                                onClick={() => {
                                                    if (window.gtag) {
                                                        window.gtag('event', 'kbo_app_click');
                                                    }
                                                    window.open('https://link-jeju.981park.com/link?target=main', '_blank', 'noopener,noreferrer');
                                                }}
                                            />
                                        )}
                                        {name === 'img-kbo5' && (
                                            <button
                                                style={naverBtnStyle}
                                                onClick={() => {
                                                    if (window.gtag) {
                                                        window.gtag('event', 'kbo_naver_click');
                                                    }
                                                    window.open('https://naver.me/xmxIgfnU', '_blank', 'noopener,noreferrer');
                                                }}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(MKboComp);
